import React, { useEffect, useState } from "react";
import PlusIcon from "../../assets/icons/plus";
import Popup from "../Common/Popup";
import Input from "../Common/CustomInput";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import api from "../../setupMiddleware";
import DepartmentTable from "../Common/DepartmentTable";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { hasPermission } from "../../Utils/auth";

const DepartmentManagement = () => {
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [departmentData, setDepartmentData] = useState([]);
  const [newDep, setNewDep] = useState({
    name: "",
    code: "",
    description: "",
  });
  const [editDep, setEditDep] = useState({});

  const { name, code, description } = newDep;

  const loading = useApiLoader();

  const getAllDepartments = async () => {
    api.get("/api/departments").then((res) => {
      if (res && res.status === 200) {
        setDepartmentData(res.data);
        setOpen(false);
        setEditOpen(false);
      }
    });
  };

  useEffect(() => {
    getAllDepartments();
  }, []);

  const addNewDepartment = async () => {
    if (!name || !code || !description) {
      alert("Please fill all the fields to add Department");
      return;
    }
    api
      .post("/api/departments", { name, code, description })
      .then((res) => {
        if (res && res.status === 201) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          getAllDepartments();
        }
      })
      .catch((err) => {
        if (err) {
          toast.error(err.response?.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
        }
      });
  };

  const handleEditDepartment = (val) => {
    setEditDep(val);
    setEditOpen(true);
  };

  const updateDepartment = async () => {
    if (!editDep?.name || !editDep?.code || !editDep?.description) {
      alert("Please fill all the fields to edit Department");
      return;
    }
    api
      .put(`/api/departments/${editDep?.id}`, {
        name: editDep?.name,
        code: editDep?.code,
        description: editDep?.description,
      })
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          getAllDepartments();
        }
      })
      .catch((err) => {
        if (err) {
          toast.error(err.response?.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
        }
      });
  };

  return (
    <>
      {loading && <Loader opacity={90} />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Department Management
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Manage All Departments
          </span>
        </p>

        {/* Right Button */}
        <div className="flex">
          {hasPermission("add_departments") && (
            <button
              onClick={() => setOpen(true)}
              className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
            >
              <PlusIcon iconClass="w-4 h-4" color="#ffffff" />
              Add New Department
            </button>
          )}
          <Popup
            isOpen={open}
            onClose={() => setOpen(false)}
            title="Add New Department"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Name</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="Enter Department Title"
                    value={name}
                    onChange={(e) =>
                      setNewDep({ ...newDep, name: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2 mb-10">
                <p className="text-sm text-[#142b70]/80">Code</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="Enter Department Code"
                    value={code}
                    onChange={(e) =>
                      setNewDep({ ...newDep, code: e.target.value })
                    }
                  />
                </div>
              </div>
              {/* <div className="flex flex-col gap-2 mb-10">
                <p className="text-sm text-[#142b70]/80">Description</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="Enter Department Description"
                    value={description}
                    onChange={(e) =>
                      setNewDep({ ...newDep, description: e.target.value })
                    }
                  />
                </div>
              </div> */}
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={addNewDepartment}
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium"
              >
                Add Department
              </button>
            </div>
          </Popup>
          {/* Edit Popup */}
          <Popup
            isOpen={editOpen}
            onClose={() => setEditOpen(false)}
            title="Edit Department"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Name</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="Enter Department Title"
                    value={editDep?.name}
                    onChange={(e) =>
                      setEditDep({ ...editDep, name: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2 mb-10">
                <p className="text-sm text-[#142b70]/80">Code</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="Enter Department Code"
                    value={editDep?.code}
                    onChange={(e) =>
                      setEditDep({ ...editDep, code: e.target.value })
                    }
                  />
                </div>
              </div>
              {/* <div className="flex flex-col gap-2 mb-10">
                <p className="text-sm text-[#142b70]/80">Description</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="Enter Department Description"
                    value={editDep?.description}
                    onChange={(e) =>
                      setEditDep({ ...editDep, description: e.target.value })
                    }
                  />
                </div>
              </div> */}
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={updateDepartment}
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium"
              >
                Update Department
              </button>
            </div>
          </Popup>
        </div>
      </div>

      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                All Departments
              </p>
            </div>
            <DepartmentTable
              data={departmentData}
              handleEdit={handleEditDepartment}
            />
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default DepartmentManagement;
